
import { computed, defineComponent, PropType, ref } from "vue";

import EasyMultiRangeSlider from "./EasyMultiRangeSlider.vue";

import { SearchFilter, SearchTravelRequest } from "@/types/models";
import { LocaleStrings, MultiRangeValues, ValueIndexParams } from "@/types/paramModels";

import { format } from "date-fns";
import * as Locales from 'date-fns/locale';

export default defineComponent({
  name: "FilterOverview",
  components: {
    EasyMultiRangeSlider
  },
  emits: [
    "updateFilterStars",
    "updateFilterCategories",
    "updateFilterMinimumPrice",
    "updateFilterMaximumPrice",
    "updateFilterPriceRange",
    "updateFilterQuery",
    "updateFilters",
  ],
  props: {
    filter: {
      type: Object as PropType<SearchFilter>,
      required: true,
    },
    isIdle: {
      type: Boolean,
    },
    searchTravelRequest: {
      type: Object as PropType<SearchTravelRequest>,
      required: true
    },
    pageTexts: {
      type: Object,
      required: true
    },
    localeStrings: {
      type: Object as PropType<LocaleStrings>,
      required: true
    }
  },
  setup(_props, { emit }) {
    const isActive = ref(false);

    const adultsCount = computed(() => _props.searchTravelRequest.rooms.reduce((acc, { adults }) => acc + adults.length, 0));
    const childrenCount = computed(() => _props.searchTravelRequest.rooms.reduce((acc, { children }) => acc + children.length, 0));
    const selectedAirport = computed(() => _props.searchTravelRequest.airports.find(x => x.isSelected));

    const toggleDropdown = () => {
      isActive.value = !isActive.value;
      if (isActive.value) document.body.classList.add("full-screen-wide-overlay");
      else document.body.classList.remove("full-screen-wide-overlay");
    };

    const closeDropdown = () => {
      isActive.value = false;
      document.body.classList.remove("full-screen-wide-overlay");
    };

    const formatDate = (dateString: string) => {
            return format(new Date(dateString), "do MMM", { locale: Locales[_props.localeStrings.name] });
        }

    const updateFilterStars = (event: Event, index: number) => {
      const input = event.target as HTMLInputElement;
      const params = { value: input.checked, index: index } as ValueIndexParams;
      emit("updateFilterStars", params);
    };

    const updateFilterCategories = (event: Event, index: number) => {
      const input = event.target as HTMLInputElement;
      const params = { value: input.checked, index: index } as ValueIndexParams;
      emit("updateFilterCategories", params);
    };

    const updateFilterMinimumPrice = (minPrice: number) => {
      emit("updateFilterMinimumPrice", minPrice);
    }

    const updateFilterMaximumPrice = (maxPrice: number) => {
      emit("updateFilterMaximumPrice", maxPrice);
    }

    const updatePriceRange = (range: MultiRangeValues) => {
      emit("updateFilterPriceRange", range);
    }

    const updateFilterQuery = () => {
      const input = document.getElementById("searchHotel") as HTMLInputElement;
      emit("updateFilterQuery", input.value);
    };

    const adultSinglePlural = (count: number) => {
      return count > 1 ? _props.pageTexts['hotelPageGeneralAdults'] : _props.pageTexts['hotelPageGeneralAdult'];
    }

    const childSinglePlural = (count: number) => {
      return count > 1 ? _props.pageTexts['hotelPageGeneralChildren'] : _props.pageTexts['hotelPageGeneralChild'];
    }

    return {
      isActive,
      adultsCount,
      childrenCount,
      selectedAirport,
      formatDate,
      toggleDropdown,
      closeDropdown,
      updateFilterStars,
      updateFilterCategories,
      updateFilterMinimumPrice,
      updateFilterMaximumPrice,
      updatePriceRange,
      updateFilterQuery,
      adultSinglePlural,
      childSinglePlural
    };
  },
});
